import React from 'react';

interface WelcomeAnimationProps {
  visible: boolean;
}

const WelcomeAnimation: React.FC<WelcomeAnimationProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center animate-fade-in-up">
      {/* Blurred backdrop */}
      <div className="absolute inset-0 bg-background-light/20 dark:bg-background-dark/20 backdrop-blur-sm" />
      
      {/* Content container */}
      <div className="relative flex flex-col items-center space-y-6">
        {/* Wave Emoji with Rotation Animation */}
        <div className="text-6xl animate-pulse-slow">
          👋
        </div>
        
        {/* Welcome Text */}
        <p className="text-2xl font-medium text-text-primary-light dark:text-text-primary-dark text-center drop-shadow-lg">
          Say HI to your interviewer
        </p>
      </div>
    </div>
  );
};

export default WelcomeAnimation; 